import type { Option } from '@usealloy/component-library';

export const parenthesisOptions: Option[] = [
  {
    label: 'Ungroup this',
    value: 'ungroup',
  },
];

export const newParenthesisOptions: Option[] = [
  {
    label: 'Open Group (',
    value: 'open',
  },
];

export const pendingParenthesisOptions: Option[] = [
  {
    label: 'Cancel opening this group',
    value: 'cancel',
  },
];
